import { ServerTimeObservation } from './corrected-clock'

/**
 * The server's clock, read off the `Date` header every HTTP response already
 * carries (#763).
 *
 * Coarser than the SignalR sync, and the point is not precision: this is the
 * one source that arrives early *and* cannot be stale, which makes it the
 * cross-check on the page shell's value, whose whole risk is staleness.
 *
 * @param dateHeader the response's `Date`, or null when there was none
 * @param requestStartMs the local clock when the request went out
 * @param responseEndMs the local clock when the response landed
 */
export function observationFromDateHeader(
    dateHeader: string | null | undefined,
    requestStartMs: number,
    responseEndMs: number,
): ServerTimeObservation | null {

    if (!dateHeader) return null;

    const stampedMs = Date.parse(dateHeader);
    if (isNaN(stampedMs)) return null;

    // `Date` is truncated to the second, so the real stamp is somewhere in
    // [stampedMs, stampedMs + 1000) and its midpoint is the best guess.
    const truncationMidpointMs = stampedMs + 500;

    // It was stamped somewhere between the request leaving and the response
    // arriving. Half the round trip is the midpoint of that too.
    const roundTripMs = Math.max(0, responseEndMs - requestStartMs);

    return {
        serverUtcMs: Math.round(truncationMidpointMs + roundTripMs / 2),
        clientUtcMs: responseEndMs,
        uncertaintyMs: Math.ceil(500 + roundTripMs / 2),
    };
}
